import React from "react";

const ordinal = (value) => `${value}${Number(value) === 1 ? "st" : Number(value) === 2 ? "nd" : "rd"}`;

export default function CompetitionDetailModal({ item, sites = [], onClose }) {
  if (!item) return null;

  const mystery = item.visibility === "mystery" && item.status !== "completed";
  const siteName = (siteId) => sites.find((site) => site.id === siteId)?.name || "Unknown location";
  const allocations = (item.winners || []).slice().sort((a, b) => Number(a.place) - Number(b.place));
  const winnersText = allocations.length
    ? allocations
        .map((winner) => `${ordinal(winner.place)}: ${siteName(winner.siteId)} · ${Number(winner.points || 0)} pts`)
        .join(" · ")
    : item.status === "completed"
      ? "Outcome completed without recorded placements."
      : "Outcome not published yet.";

  return (
    <div className="league-modal-backdrop">
      <div className="league-modal league-event-detail">
        <p>{mystery ? "Mystery competition" : "Competition details"}</p>
        <h2>{mystery ? "Mystery event" : item.name}</h2>
        <div className="league-event-detail-grid">
          <div>
            <span>Schedule</span>
            <strong>{item.startDate || "TBC"} {item.startTime || ""} → {item.endDate || "TBC"} {item.endTime || ""}</strong>
          </div>
          <div>
            <span>Category</span>
            <strong>{mystery ? "Hidden until reveal" : item.category || "General operations"}</strong>
          </div>
          <div>
            <span>Eligible league</span>
            <strong>{item.division === "all" ? "Gold & Silver" : `${String(item.division || "gold").replace(/^./, (c) => c.toUpperCase())} League`}</strong>
          </div>
          <div>
            <span>Points available</span>
            <strong>{(item.places || []).map((place) => `${ordinal(place.place)}: ${place.points} pts`).join(" · ")}</strong>
          </div>
          <div>
            <span>Participation points</span>
            <strong>{Number(item.participationPoints || 0)} pts</strong>
          </div>
          <div className="league-winners-card">
            <span>{allocations.length ? "Winners" : "Status"}</span>
            <strong>{winnersText}</strong>
          </div>
          {item.awardEnabled ? (
            <div className="wide">
              <span>Award</span>
              <strong>{item.awardType}{item.awardDescription ? ` · ${item.awardDescription}` : ""}</strong>
            </div>
          ) : null}
          <div className="wide">
            <span>Description</span>
            <strong>{mystery ? "Details will be revealed when the outcome is published." : item.description || "No description provided."}</strong>
          </div>
        </div>
        <div className="league-modal-actions">
          <button className="league-primary-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
